export default __webpack_public_path__ + "static/media/logo.27a04ccb.png";